import React, { Component } from 'react';
import moment from 'moment';
import Select from 'react-select';

class YearSelect extends Component {
  constructor(props) {
    super(props);
    this.yearOptions = [];

    const now = moment();
    const year = now.year();

    for (let i = 0; i < 100; i++) {
      this.yearOptions.push({
        value: year - i,
        label: `${year - i}`,
      });
    }
  }

  getOption = (value) => {
    const object = this.yearOptions.find(o => o.value === value);
    return object || value;
  };

  render() {
    return (
      <Select
        {...this.props}
        value={this.getOption(this.props.value)}
        options={this.yearOptions}
      />
    );
  }
}

export default YearSelect;



// WEBPACK FOOTER //
// ./src/components/YearSelect/index.js